<template>
	<div :style="curtainStyle">
		<template v-if="$slots['b-view'] && showB">
			<slot name="b-view"></slot>
		</template>
		<slot v-else></slot>
	</div>
</template>

<script>
import { AbtestCurtainMixin } from "../../mixins/abtestCurtain";

export default {
	name: "abtest-curtain",
	mixins: [AbtestCurtainMixin]
};
</script>
